module.exports = __webpack_public_path__ + "img/back-arrow.2c61394c.svg";